import React from 'react';
import { useSelector } from 'react-redux';

import { Icon, TooltipWrapper } from '@tcc/crate';

import { getCurrency } from 'user/userSelectors';
import { currencyFormatter, getMessage } from 'util/locale';
import { inferUnit } from 'util/unitConversion';

const EstimatedGrossRevenueRow = ({
  orginalProjectedRevenue,
  activeProjectedRevenue,
  yourPlanProjectedRevenue
}: {
  orginalProjectedRevenue: number;
  activeProjectedRevenue: number;
  yourPlanProjectedRevenue: number;
}) => {
  const currency = useSelector(getCurrency);
  const baseString = 'vra-scenarios-table-gross-revenue';

  return (
    <tr className={baseString}>
      <th role='rowheader'>
        {getMessage('est-gross-revenue-area', { areaUnit: inferUnit('area').symbol.universal })}
        <TooltipWrapper
          content={[getMessage('est-gross-revenue-equation', { areaUnit: inferUnit('area').label.universal })]}
          mode='secondary'
          placement='right'
          title={getMessage('gross-revenue')}
        >
          <Icon glyph={Icon.set.INFO_CIRCLE} />
        </TooltipWrapper>
      </th>
      <td>{currencyFormatter(yourPlanProjectedRevenue, currency, { round: true })}</td>
      <td>{currencyFormatter(orginalProjectedRevenue, currency, { round: true })}</td>
      <td>{currencyFormatter(activeProjectedRevenue, currency, { round: true })}</td>
    </tr>
  );
};

export default EstimatedGrossRevenueRow;
